import { EventEmitter } from 'events';

export type Quality = 'MIN' | 'LOW' | 'MEDIUM' | 'HIGH' | 'MAX';

export const QUALITY_VALUES: Quality[] = [
  'MIN',
  'LOW',
  'MEDIUM',
  'HIGH',
  'MAX',
];

const MaximumScreenSpaceErrorQualityAliases: Record<Quality, number> = {
  MIN: 128,
  LOW: 56,
  MEDIUM: 16,
  HIGH: 8,
  MAX: 1,
};

let active: Quality = 'MEDIUM';

interface QualityEmitterEvents {
  change: (value: Quality) => void;
}

class QualityEmitter extends EventEmitter {
  on<U extends keyof QualityEmitterEvents>(
    event: U,
    listener: QualityEmitterEvents[U],
  ): this {
    return super.on(event, listener);
  }

  emit<U extends keyof QualityEmitterEvents>(
    event: U,
    ...args: Parameters<QualityEmitterEvents[U]>
  ): boolean {
    return super.emit(event, ...args);
  }
}

export const quality = {
  emitter: new QualityEmitter(),
  get value(): Quality {
    return active;
  },
  set value(val: Quality) {
    active = val;
    this.emitter.emit('change', val);
  },
  getMaximumScreenSpaceError(): number {
    return MaximumScreenSpaceErrorQualityAliases[active];
  },
};
